import React from 'react'

import { Provider as TooltipProvider } from '@radix-ui/react-tooltip'

import WalletConnectProvider from '@/context/wallet-connect.provider'

import { Outlet } from 'react-router-dom'

import { Toaster } from './components/ui/toaster'
import { DataProvider, MultiWalletProvider, SettingProvider, ThemeProvider, TokenProvider } from './context'

const composeProviders =
  (...providers: React.ComponentType<{ children: React.ReactNode }>[]) =>
  ({ children }: { children: React.ReactNode }) => {
    return providers.reduceRight((child, Provider) => <Provider>{child}</Provider>, children)
  }

const Providers = composeProviders(
  ThemeProvider,
  WalletConnectProvider,
  DataProvider,
  MultiWalletProvider,
  SettingProvider,
  TokenProvider
)
const App: React.FC = () => {
  return (
    <Providers>
      <Toaster />
      <TooltipProvider delayDuration={300} skipDelayDuration={100}>
        <div vaul-drawer-wrapper='' className='bg-background'>
          <Outlet />
        </div>
      </TooltipProvider>
    </Providers>
  )
}

export default App
